@if (isValidating() || isDownloading()) {
<div class="overlay">
  <div class="spinner"></div>
  <p class="text-load">{{ isValidating() ? 'Validating...' : 'Downloading...' }}</p>
</div>
}

<!-- Breadcrumb bar -->
<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <a class="breadcrumb-link" [routerLink]="['/planning']">Planning</a>
    <span class="breadcrumb-sep" aria-hidden="true"></span>
    <span class="breadcrumb-current">Import Standard Review</span>
  </div>
</div>

<!-- Main content -->
<main class="import-main">
  <!-- Header card -->
  <section class="header-card">
    <h2 class="header-title">Import Standard Review</h2>
  </section>

  <!-- Body card -->
  <section class="body-card">
    <div class="inner-box">
      <div class="action-row">
        <label class="import-btn" [class.import-btn-disabled]="isValidating()" (click)="isValidating() ? $event.preventDefault() : validationResult.set(null)">
          <span class="import-btn-icon">
            <svg width="18" height="24" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" transform="rotate(-45)">
              <path
                d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
            </svg>
          </span>
          <span class="import-btn-text">Import Excel File</span>
          <input #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)" hidden />
        </label>

        <button type="button" class="template-link" (click)="downloadTemplate()">
          Download the Latest Import Template
        </button>
      </div>

      @if (hasImportErrors()) {
      <div class="import-error-section">
        <div class="import-error-single-line-section">
          @for (err of singleLineErrors(); track $index) {
          <div class="import-error-line">
            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" class="import-error-icon" role="img"
              aria-label="Error icon">
              <path
                d="M11.5938 0.162109L0.59375 19.1621H22.5938M11.5938 4.16211L19.1238 17.1621H4.06375M10.5938 8.16211V12.1621H12.5938V8.16211M10.5938 14.1621V16.1621H12.5938V14.1621"
                fill="#FF3246" />
            </svg>
            <span class="import-error-message">{{ err.error }}</span>
          </div>
          }
        </div>

        @if (rowLevelErrors().length) {
        <div class="import-error-row-level-section">
          <table class="import-error-table" role="table" aria-label="Import Errors Table">
            <thead class="import-error-table-header">
              <tr>
                <th class="import-error-cell-row">Row Number</th>
                <th class="import-error-cell-review-name">Review Name</th>
                <th class="import-error-cell-field">Field Name(s)</th>
                <th class="import-error-cell-error">Error Description</th>
              </tr>
            </thead>
            <tbody>
              @for (err of rowLevelErrors(); track $index) {
              <tr class="import-error-table-row">
                <td class="import-error-cell-row">{{ err.row }}</td>
                <td class="import-error-cell-review-name">{{ err.reviewName }}</td>
                <td class="import-error-cell-field">{{ err.field }}</td>
                <td class="import-error-cell-error">{{ err.error }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
      </div>
      }

      <div class="instructions-section">
        <h3 class="instructions-title">Instruction Related to Import File</h3>
        <p class="instructions-intro">
          <em>
            If you are running the import for the first time or you need detailed directions, please read the Detailed Instructions
          </em>
        </p>

        <ol class="instructions-list">
          <li>
            <strong>Template Format</strong>: The uploaded file must be in the correct
            <a class="inline-link" (click)="downloadTemplate()">Excel template format</a>.
            Data outside of the designated structure will result in an import failure.
          </li>
          <li>
            <strong>Template Version:</strong> Only the latest supported version of the Excel template
            is accepted for import. Please ensure you are using the most recent template.
          </li>
          <li>
            <strong>File Size Limit:</strong> The maximum allowable file size for import is
            20 MB. Files exceeding this limit must be split and
            imported separately.
          </li>
          <li>
            <strong>Record Limit:</strong> A single import operation is limited to a maximum of
            100 records. For larger datasets, please divide the file.
          </li>
          <li>
            <strong>User Permissions:</strong> You must have the necessary permissions within the
            system to create a new review and initiate a data import.
          </li>
          <li>
            <strong>Offline Approval Status:</strong> Confirmation of offline approval for the data
            you are importing must be secured before starting the upload process.
          </li>
        </ol>
      </div>
    </div>
  </section>
</main>

<!---Import Standard Review Success / Error Toast--->
<ng-template #importReviewToast let-data>
  <div role="status" class="import-review-toast-container" aria-labelledby="import-review-toast-header" [ngClass]="{
         'import-review-toast-success': data.title === 'success',
         'import-review-toast-error':   data.title === 'error'
       }">

    <div class="import-review-toast-img-container" [ngClass]="{
           'import-review-toast-success-img': data.title === 'success',
           'import-review-toast-error-img':   data.title === 'error'
         }">
      @if (data.title === 'success') {
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" role="img" aria-label="Success Icon"
        class="import-review-toast-icon">
        <circle cx="10.5" cy="10.5" r="8.5" stroke="#408342" stroke-width="2.5" />
        <path d="M6.3 10.7L9.4 13.6L14.4 7.1" stroke="#408342" stroke-width="2.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      } @else {
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" role="img" aria-label="Error Icon"
        class="import-review-toast-icon">
        <circle cx="10" cy="10" r="8.75" stroke="#FF3246" stroke-width="2.5" />
        <path d="M7.5 7.5L12.5 13M12.5 7.5L7.5 13" stroke="#FF3246" stroke-width="2.2" stroke-linecap="round" />
      </svg>
      }
    </div>

    <div class="import-review-toast-message-container">
      <h2 id="import-review-toast-header" class="import-review-toast-header" [ngClass]="{
            'import-review-toast-success-header': data.title === 'success',
            'import-review-toast-error-header':   data.title === 'error'
          }">
        {{data.header}}
      </h2>
      <p id="import-review-toast-content">
        {{data.content}}
        @if (data.link) {
          <a [routerLink]="data.link.route" mat-dialog-close class="import-review-toast-link">{{data.link.text}}</a>
        }
      </p>
    </div>

    <button mat-dialog-close aria-label="Close toast" class="import-review-toast-close-btn">
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" role="img" aria-label="close icon">
        <path d="M1 1L12 13M12 1L1 13" stroke="#B3B2B5" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</ng-template>